import { OPEN_IN_BROWSER, ERROR_SHOW, ERROR_TEXT } from './actionTypes';

export const getOpenInBrowserAction = (value) => {
  return {
    type: OPEN_IN_BROWSER,
    value
  }
}

export const setOpenInBrowserFalse = () => {
  return (dispatch) => {
    const action = getOpenInBrowserAction(false);
    dispatch(action);
  }
}

export const getErrorShowAction = (value) => {
  return {
    type: ERROR_SHOW,
    value
  }
}

export const getErrorTextAction = (value) => {
  return {
    type: ERROR_TEXT,
    value
  }
}
